import { STATUS_LABEL } from "../lib/api";

const STYLES = {
  uploaded: "bg-slate-100 text-slate-700 border-slate-300",
  processing: "bg-blue-50 text-blue-700 border-blue-200 animate-pulse",
  needs_review: "bg-amber-50 text-amber-800 border-amber-300 font-semibold",
  confirmed: "bg-emerald-50 text-emerald-800 border-emerald-300",
  failed: "bg-rose-50 text-rose-800 border-rose-300",
};

export function StatusBadge({ status, className = "" }) {
  return (
    <span data-testid={`status-badge-${status}`} className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs whitespace-nowrap ${STYLES[status] || STYLES.uploaded} ${className}`}>
      {STATUS_LABEL[status] || status}
    </span>
  );
}

export function PageHeader({ title, subtitle, actions }) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 mb-6 fade-up">
      <div>
        <h1 className="text-2xl sm:text-3xl font-bold tracking-tight text-slate-900">{title}</h1>
        {subtitle && <p className="text-sm text-slate-500 mt-1">{subtitle}</p>}
      </div>
      {actions && <div className="flex gap-2 flex-wrap">{actions}</div>}
    </div>
  );
}

export function EmptyState({ icon: Icon, title, hint, action, testId }) {
  return (
    <div className="border border-dashed border-slate-300 rounded-lg p-10 text-center bg-white" data-testid={testId}>
      {Icon && <Icon className="mx-auto h-10 w-10 text-slate-300 mb-3" />}
      <p className="font-medium text-slate-800">{title}</p>
      {hint && <p className="text-sm text-slate-500 mt-1">{hint}</p>}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}
